import { CircleCheckSolid, CircleExclamationSolid } from '@allocab/allocab-icons';

type Props = {
  isValid: boolean;
};

export const ValidationMark = ({ isValid }: Props) => {
  return isValid ? (
    <CircleCheckSolid width={15} height={15} className="fill-green-700 dark:fill-green-600" />
  ) : (
    <CircleExclamationSolid width={15} height={15} className="fill-red-700 dark:fill-red-600" />
  );
};
